export default __webpack_public_path__ + "static/media/error_bg.b02ebe12.png";